/**
 * Jeton lu dans le fragment de l'URL (`#…`) : le fragment n'est jamais envoyé au serveur ni
 * transmis dans l'en-tête Referer. Les liens d'invitation, de réinitialisation et du portail
 * sont construits ainsi par l'API.
 */
export function readHashToken(): string {
  if (typeof window === 'undefined') return '';
  const raw = window.location.hash.replace(/^#/, '');
  try {
    return decodeURIComponent(raw).trim();
  } catch {
    return raw.trim();
  }
}

/** Retire le jeton de la barre d'adresse et de l'historique après usage (jeton à usage unique). */
export function clearHash(): void {
  if (typeof window === 'undefined' || !window.location.hash) return;
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
}
